import React, { useMemo, useState, useEffect } from 'react'
import '../../components/kyc/kycStyle.css'
import './EuaEnquiry.css'
import FooterButtons from '../../components/form/FooterButtons/FooterButtons'
import { API_ERROR_MESSAGE, PRICELIST } from '../../utils/Constants'
import { RESTRICTED_REPORT } from '../../utils/Constants'
import ScreenLayout from '../../components/layouts/ScreenLayout'
import EuaEnquiryResults from '../../components/EuaEnquiry/EuaEnquiryResults'
import EuaEnquiryDetails from '../../components/EuaEnquiry/EuaEnquiryDetails'
import { useMutation } from 'react-query'
import {
  requestEuaQuery,
  requestEuaPropertyEnquiry,
} from '../../api/euaEnquiry'
import { Spinner, Table } from 'react-bootstrap'

type DeedsQueryProps = {
  setShow: (value: boolean) => void
  setIsError: (arg0: boolean) => void
  setErrorMessage: (value: string) => void
  KYCAccess: boolean
  handleClose: () => void
}

const EuaEnquiry: React.FC<DeedsQueryProps> = ({
  setShow,
  setIsError,
  handleClose,
  setErrorMessage,
  KYCAccess,
}) => {
  const [hfDeedsOfficeName] = useState(
    (document.getElementById('hfDeedsOfficeName') as HTMLInputElement)?.value ||
      (process.env.REACT_APP_ENV === 'DEV' ? '' : ''),
  )
  // const [hfAgentEmail] = useState(
  //   (document.getElementById('hfAgentEmail') as HTMLInputElement)?.value ||
  //     (process.env.REACT_APP_ENV === 'DEV' ? '' : ''),
  // )
  const [hfAgentEmail] = useState('support@cmainfo.co.za')

  const [hfSTSchemeName, setHfSchemeName] = useState(() => {
    const inputValue =
      (document.getElementById('hfSTSchemeName') as HTMLInputElement)?.value ||
      ''
    if (!inputValue.startsWith('SS ')) {
      return 'SS ' + inputValue
    }
    return inputValue
  })

  const [hfSTPlanNo] = useState(
    (document.getElementById('hfSTPlanNo') as HTMLInputElement)?.value ||
      (process.env.REACT_APP_ENV === 'DEV' ? '' : ''),
  )
  const [hfSectionNo] = useState(
    (document.getElementById('hfSectionNo') as HTMLInputElement)?.value ||
      (process.env.REACT_APP_ENV === 'DEV' ? '' : ''),
  )
  const [hfDeedsOfficeID] = useState(
    (document.getElementById('hfDeedsOfficeID') as HTMLInputElement)?.value ||
      (process.env.REACT_APP_ENV === 'DEV' ? '' : ''),
  )
  const [selectedItems, setSelectedItems] = useState<string[]>([])
  const [apiResponse, setApiResponse] = useState<any>(null)
  const [isLoadingProceed, setIsLoadingProceed] = useState(false)
  const resetSelectedItems = () => {
    setSelectedItems([])
  }
  const [isLoadingPropertyEnquiry, setIsLoadingPropertyEnquiry] =
    useState(false)
  const { mutate: requestPropertyEnquiry } = useMutation(
    'property-enquiry',
    requestEuaPropertyEnquiry,
    {
      onSuccess: (data) => {
        console.log('Property Enquiry Success:', data)
        if (data.statusCode === 200) {
          window.alert('A copy has been emailed to you.')
          resetSelectedItems()
          setIsLoadingPropertyEnquiry(false)
        }
      },
      onError: (error) => {
        console.error('Property Enquiry Error:', error)
        alert('Request failed, please try again.')
      },
    },
  )
  useEffect(() => {
    console.log('isLoadingPropertyEnquiry:', isLoadingPropertyEnquiry)
  }, [isLoadingPropertyEnquiry])
  const handleToggleSelection = (exclusiveUsageNumber: string) => {
    const isSelected = selectedItems.includes(exclusiveUsageNumber)
    setSelectedItems((prevSelectedItems) => {
      if (isSelected) {
        return prevSelectedItems.filter((item) => item !== exclusiveUsageNumber)
      } else {
        return [...prevSelectedItems, exclusiveUsageNumber]
      }
    })
  }

  const handleProceed = async () => {
    try {
      setIsLoadingPropertyEnquiry(true)
      await requestPropertyEnquiry({
        officeCode: hfDeedsOfficeID,
        schemeName: hfSTSchemeName,
        schemeNumber: hfSTPlanNo,
        exclusiveUsageNumber: selectedItems,
      })
    } catch (error) {
      console.log(error)
    }
  }
  const handlePropertyEnquiry = async (exclusiveUsageNumber: string) => {
    try {
      setIsLoadingPropertyEnquiry(true)
      await requestPropertyEnquiry({
        officeCode: hfDeedsOfficeID,
        schemeName: hfSTSchemeName,
        schemeNumber: hfSTPlanNo,
        exclusiveUsageNumber: [exclusiveUsageNumber],
      })
    } finally {
      setIsLoadingPropertyEnquiry(false)
    }
  }
  const { mutate: proceed } = useMutation(
    'deeds-query-proceed',
    requestEuaQuery,
    {
      onSuccess: (data) => {
        if (data.data[0].exclusiveUsageNumber === null) {
          alert(
            'No results found for this scheme. You have been billed R29.50 excl VAT for this search.',
          )
        } else {
          setApiResponse(data.data)
          resetSelectedItems()
        }
        setIsLoadingProceed(false)
      },
      onError: (error) => {
        console.error('Error:', error)
        setIsError(true)
        setErrorMessage(API_ERROR_MESSAGE)
        setIsLoadingProceed(false)
      },
    },
  )
  useEffect(() => {
    console.log('apiResponse changed:', apiResponse)
  }, [apiResponse])

  const errorResult = () => {
    if (
      hfDeedsOfficeName.length === 0 ||
      hfSTSchemeName.length === 0 ||
      hfSTPlanNo.length === 0 ||
      hfSectionNo.length === 0
    ) {
      return true
    } else {
      return false
    }
  }

  const handleSearch = async () => {
    setIsLoadingProceed(true)
    try {
      await proceed({
        officeCode: hfDeedsOfficeID,
        schemeName: hfSTSchemeName,
        schemeNumber: hfSTPlanNo,
      })
    } catch (error) {
      console.log(error)
    }
  }

  if (apiResponse && apiResponse.length > 0)
    return (
      <ScreenLayout
        headerText="EUA - Exclusive Use Enquiry"
        subHeaderText="Providing a detailed report on the exclusive use of a scheme"
        price={PRICELIST.EUA_ENQUIRY}
      >
        <EuaEnquiryResults
          apiResponse={apiResponse}
          selectedItems={selectedItems}
          isLoadingPropertyEnquiry={isLoadingPropertyEnquiry}
          handleToggleSelection={handleToggleSelection}
          handleProceed={handleProceed}
          handleClose={handleClose}
        />
      </ScreenLayout>
    )

  return (
    <ScreenLayout
      headerText="EUA - Exclusive Use Enquiry"
      subHeaderText="Providing a detailed report on the exclusive use of a scheme"
      price={PRICELIST.EUA_ENQUIRY}
    >
      {isLoadingProceed && (
        <div className="spinner-container">
          <Spinner
            as="span"
            animation="border"
            variant="dark"
            role="status"
            aria-hidden="true"
          ></Spinner>
          <span> </span>
        </div>
      )}
      {KYCAccess !== true && <p className="lbl-red">{RESTRICTED_REPORT}</p>}
      <div className="info-display-container">
        {!errorResult() ? (
          <EuaEnquiryDetails
            deedsRegistry={hfDeedsOfficeName}
            schemeName={hfSTSchemeName}
            schemeNo={hfSTPlanNo}
            sectionNo={hfSectionNo}
          />
        ) : (
          <>
            <span className="eua-enquiry-error-value">
              No property information available - Please go to Property Search
              to select a Sectional Title Unit / Section in a Sectional Title
              Scheme.
            </span>
            <br />
            <br />
          </>
        )}
      </div>

      <p>
        An enquiry done with no exclusive use will still be billed to your
        account.
      </p>
      <FooterButtons
        handleSearch={handleSearch}
        searchChildren="Search"
        setShow={setShow}
      />
      <div className="spacer" />
    </ScreenLayout>
  )
}
export default EuaEnquiry
